import { PlatformType } from '@/types';

export const THEME_TYPES = {
  THEME_DARK: 'dark',
  THEME_LIGHT: 'light',
};

export const Platform: PlatformType = process.env
  .NEXT_PUBLIC_PLATFORM as PlatformType;
